import { Analytics as ExpoAnalytics, PageHit } from 'expo-analytics';

export class Analytics {
  constructor(private analytics: ExpoAnalytics) {}

  sendPageView(pageName?: string): void {
    if (!pageName) return;

    this.analytics.hit(new PageHit(pageName));
  }
}

export default new Analytics(
  new ExpoAnalytics(process.env.EXPO_APP_GA_TRACKING_ID as string)
);
